import palette from '../palette';

export default function Input() {
  return {
    MuiInputBase: {
      input: {
        color: palette.text.main,
        fontSize: 14,
        fontWeight: 400,
        height: 10
      },

      root: {
        '&.Mui-error, &$focused': {
          borderColor: '#F48989'
        },

        '&.MuiFilledInput-underline:before, &.MuiFilledInput-underline:after': {
          display: 'none'
        }
      }
    },

    MuiFilledInput: {
      root: {
        border: '1px solid #CDCED9',
        borderRadius: '4px',
        backgroundColor: '#fff',

        '&:hover': {
          backgroundColor: '#fff'
        },
        '&$focused': {
          backgroundColor: '#fff',
          boxShadow: `none`,
          borderColor: '#FDC10E'
        },
        '&.Mui-disabled': {
          // backgroundColor: theme.palette.action.disabledBackground
        },
        '&.Mui-error, &.Mui-error$focused': {
          borderColor: '#F48989'
        }
      }
    },

    MuiOutlinedInput: {
      root: {
        border: '0.5px solid #CDCED9',
        borderRadius: '4px',
        backgroundColor: '#fff',

        '&:hover': {
          backgroundColor: '#fff'
        },
        '&$hover': {
          backgroundColor: '#fff',
          boxShadow: `none`,
          borderColor: '#FDC10E'
        },
        '&$focused': {
          backgroundColor: '#fff',
          boxShadow: `none`,
          borderColor: '#FDC10E'
        },
        '&.Mui-disabled': {
          // backgroundColor: theme.palette.action.disabledBackground
        },

        '&.Mui-error, &.Mui-error$focused': {
          borderColor: '#F48989'
        },

        '& .MuiOutlinedInput-notchedOutline': {
          border: 0
        }
      },

      input: {
        paddingLeft: 12,
        paddingRight: 12
      }
    },

    MuiAutocomplete: {
      root: {
        '& .MuiFilledInput-underline:before, & .MuiFilledInput-underline:after':
          {
            display: 'none'
          }
      }
    },

    MuiSelect: {
      root: {
        '&.MuiSelect-filled.MuiSelect-filled': {
          paddingTop: 24,
          paddingBottom: 5
        }
      }
    }
  };
}
